// extracted by mini-css-extract-plugin
module.exports = {"controlBar":"styles_controlBar__fB732","nakedButton":"styles_nakedButton__ChFlZ","addReviewBtn":"styles_addReviewBtn__hoWYw"};